import type { QueryRecord } from '../widget-api/http-client';

/** Параметры ключа/подписи виджета из `URLSearchParams` — для `GET /public/trainers` и др. */
export function widgetAuthQueryFromSearchParams(searchParams: URLSearchParams): QueryRecord {
  const q: QueryRecord = {};
  const key = searchParams.get('key')?.trim();
  const kid = searchParams.get('kid')?.trim();
  const exp = searchParams.get('exp')?.trim();
  const sig = searchParams.get('sig')?.trim();
  const embedGlobal = searchParams.get('embed_global')?.trim();
  if (key) q.key = key;
  if (kid) q.kid = kid;
  if (exp) q.exp = exp;
  if (sig) q.sig = sig;
  if (embedGlobal) q.embed_global = embedGlobal;
  return q;
}

export function hasWidgetAuthQuery(searchParams: URLSearchParams): boolean {
  const key = searchParams.get('key')?.trim();
  if (key) return true;
  const kid = searchParams.get('kid')?.trim();
  const exp = searchParams.get('exp')?.trim();
  const sig = searchParams.get('sig')?.trim();
  return Boolean(kid && exp && sig);
}
